<template>
  <div style="width: 100%;height: 100%;">
    <p style="font-size: 16px;font-weight: 600;color: #333;height: 40px">当前选中：<span
      style="color: orangered">{{ showName }}</span></p>
    <div style="width: 100%;height: calc(100% - 80px);overflow-y: auto;">
      <Tree ref="tree" multiple :data="treeList" :load-data="loadData" @on-select-change="onSelectChange"/>
    </div>
    <Button type="primary" @click="saveBotton">确定</Button>
  </div>
</template>

<script>
export default {
  props: {
    treeList: {
      type: [Array],
      default: [],
    },
  },
  data() {
    return {
      idlist: [],
      valuecopy: [],
      showName: ''
    }
  },
  methods: {
    geTree() {
      this.showName = ''
      this.idlist = []
    },
    onSelectChange(list) {
      let that = this
      that.idlist = list.map(it => {
        return it.value
      })
      let nameList = list.map(it => {
        return it.title
      })
      this.showName = nameList.join(' ')
    },
    saveBotton() {
      this.$emit('setReturn', this.idlist)
    },
    findInTreeArray(tree) {
      treeListfor(tree)
      function treeListfor(tree) {
        for (let i = 0; i < tree.length; i++) {
          tree[i].selected = false
          if (tree[i].children && tree[i].children.length > 0) {
            treeListfor(tree[i].children);
          }
        }
      }
    },
    loadData(item, callback){
      let that = this
      if(item.childzj>0){
        let cond = {
          pid:item.zhongtuclass_id
        }
        var arr = []
        that.$httpsencrypt.post('api/base/v3/zhongtuclassweb/treeindex', cond).then(val => {
          if(val.code==200&&val.data.length){
            arr = val.data.map((it,ind)=>{
              if(it.child&&it.child>0){
                return {
                  title:(it.alis?it.alis:'')+' '+(it.titlelang&&it.titlelang.zh?it.titlelang.zh:''),
                  expand: false,
                  loading: false,
                  value: it.alis?it.alis:'',
                  selected: false,
                  checked: false,
                  zhongtuclass_id:it.zhongtuclass_id,
                  pid:it.pid,
                  childzj:it.child?it.child:'',
                  children:[]
                }
              }else {
                return {
                  title:(it.alis?it.alis:'')+' '+(it.titlelang&&it.titlelang.zh?it.titlelang.zh:''),
                  expand: false,
                  value: it.alis?it.alis:'',
                  selected: false,
                  checked: false,
                  zhongtuclass_id:it.zhongtuclass_id,
                  pid:it.pid,
                  childzj:it.child?it.child:'',
                }
              }
            })
          }
          callback(arr)
        })
      }else {
        callback([])
      }
    }
  },

  mounted() {
    this.findInTreeArray(this.treeList)
  },
  created() {
    this.geTree()

  },

}
</script>
